import { GatePass } from './../../../_models/gate_pass';


import { AuthService } from './../../../_services/auth.service';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-menu',
  templateUrl: './report-menu.component.html',
  styleUrls: ['./report-menu.component.css']
})
export class ReportMenuComponent implements OnInit {
   @Input() gatePass:GatePass=undefined

  constructor(
    public authService:AuthService
  ) { }

  ngOnInit(): void {
  }

}
